'use strict';

const Swiper = require('../thirdParty/swiper');

// ボタンIDでonclick
document.getElementById('btn_swiper_setting').onclick = function () {
    /**
     * Swiperスクリプト：商品スライド
     */
    const swiperRecommend = new Swiper('.swiper_recommend', {
        breakpoints: {
            // ブレークポイント
            0: {
                // 画面幅0px以上で適用
                slidesPerView: 2,
            },
            768: {
                // 画面幅769px以上で適用
                slidesPerView: 3,
            },
            1200: {
                // 画面幅1200px以上で適用
                slidesPerView: 4,
            },
        },
        loop: true, // ループさせる
        speed: 1500, // 少しゆっくり(デフォルトは300)
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
};
